class CustomColorSelector extends HTMLElement {
  swatch;
  popup;
  colorInput;
  hiddenInput;
  productForm;
  addButton;
  customColorSwatch;
  selectedColorEl;

  connectedCallback() {
    this.swatch = this.querySelector('.custom-color-selector__swatch');
    this.popup = this.querySelector('.custom-color-popup');
    this.addButton = this.querySelector('.custom-color-popup__button');
    this.colorInput = this.querySelector('#custom-color-input');
    this.selectedColorEl = this.querySelector('.custom-color-selector__selected-color');
    this.productForm = document.querySelector('form[action="/cart/add"]');
    this.customColorSwatch = document.querySelector('.swatch-input__label[title="Custom Color"]');

    this.swatch.addEventListener('click', this.onSwatchClick.bind(this));
    this.addButton.addEventListener('click', this.onAddBtnClick.bind(this));

    this.colorInput.addEventListener('change', (event) => {
      event.stopPropagation();
    });

    if (window.productCustomColor) {
      this.showSelectedColor();
      this.swatch.classList.add('active');
      this.createHiddenInput();
    } else {
      // reset to default if custom color variant is selected without picking a variant
      const customColorSwatch = document.querySelector('.swatch-input__input[value="Custom Color"]:checked');
      if (customColorSwatch.checked) {
        const url = new URL(window.location.href, window.location.origin);
        url.searchParams.delete('variant');
        location.href = url.toString();
      }
    }
  }

  disconnectedCallback() {
    this.removeHiddenInput();
    delete window.productCustomColor;
  }

  onSwatchClick() {
    this.openPopup();
  }

  onAddBtnClick(event) {
    event.preventDefault();

    if (this.colorInput.value !== '') {
      window.productCustomColor = this.colorInput.value;
      this.showSelectedColor();
      this.swatch.classList.add('active');
      this.closePopup();
      this.customColorSwatch.click();
    }
  }

  showSelectedColor() {
    this.selectedColorEl.textContent = 'Custom color: ' + window.productCustomColor;
  }

  createHiddenInput() {
    this.hiddenInput = document.createElement('input');
    this.hiddenInput.setAttribute('type', 'hidden');
    this.hiddenInput.setAttribute('name', 'properties[Custom Color]');
    this.hiddenInput.setAttribute('value', window.productCustomColor);

    this.productForm.appendChild(this.hiddenInput);
  }

  removeHiddenInput() {
    if (this.hiddenInput) {
      this.hiddenInput.remove();
    }
  }

  openPopup() {
    this.popup.setAttribute('aria-expanded', 'true');
  }

  closePopup() {
    this.popup.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('custom-color-selector')) {
  customElements.define('custom-color-selector', CustomColorSelector);
}